import { useCallback, useEffect, useState } from "react";
import { Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, imgSrc } from "../../lib/api";
import { ItemForm } from "./ItemForm";

export const CrudManager = ({ name, label, title, subtitle, fields }) => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null); // null | {} (new) | item

  const load = useCallback(() => api.adminList(name).then(setItems).catch((e) => toast.error(errMsg(e))), [name]);
  useEffect(() => {
    load();
  }, [load]);

  const save = async (body) => {
    try {
      if (editing.id) await api.adminUpdate(name, editing.id, body);
      else await api.adminCreate(name, body);
      toast.success(`Saved ${label}`);
      setEditing(null);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const remove = async (item) => {
    if (!window.confirm(`Delete this ${label}?`)) return;
    try {
      await api.adminDelete(name, item.id);
      toast.success("Deleted");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid={`admin-${name}-manager`}>
      {editing ? (
        <ItemForm fields={fields} item={editing} label={label} onSave={save} onCancel={() => setEditing(null)} testid={`admin-${name}-form`} />
      ) : (
        <button onClick={() => setEditing({})} data-testid={`admin-${name}-add-button`} className="btn-lime rounded-full px-6 py-3 font-cond uppercase font-bold tracking-widest inline-flex items-center gap-2 mb-6">
          <Plus className="w-4 h-4" /> Add {label}
        </button>
      )}
      <div className="space-y-3 mt-6">
        {items.length === 0 && <p className="text-slate-500 text-sm">Nothing here yet.</p>}
        {items.map((x) => (
          <div key={x.id} data-testid={`admin-${name}-row-${x.id}`} className="card-surface rounded-xl p-4 flex items-center gap-4">
            {x.image_url && <img src={imgSrc(x.image_url)} alt="" className="w-14 h-14 rounded-lg object-cover shrink-0" />}
            <div className="flex-1 min-w-0">
              <p className="font-semibold truncate">{title(x)}</p>
              <p className="text-xs text-slate-400 truncate">{subtitle(x)}</p>
            </div>
            <button onClick={() => setEditing(x)} data-testid={`admin-${name}-edit-${x.id}`} className="btn-line rounded-full p-2.5" aria-label="Edit"><Pencil className="w-4 h-4" /></button>
            <button onClick={() => remove(x)} data-testid={`admin-${name}-delete-${x.id}`} className="btn-line rounded-full p-2.5 hover:!text-red-400 hover:!border-red-400" aria-label="Delete"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
